<template>
  <div class="template-container">
    <div v-html="html">

    </div>
    
  </div>
</template>


<style scoped>
.template-container {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: black;
}

.template-frame {
  border: none;
  width: 100%;
  height: 100%;
}

/* Exempel: om du ändå vill tvinga vit bakgrund inne i iframe-sidan   */
:deep iframe {
  background: white;
}
</style>


<script>
import messageParent from '@/core/services/messageParent';
import dayjs from 'dayjs';
import axios from 'axios';

import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { get_domain_ws_url } from '@/core/services/fileDownload';

export default {
  name: 'PublicTemplateView',
  mixins: [ toasts ],

  components: {
    
  },

  data() {
    return {
      template: {},
      html: null
    };
  },
  mounted() {
    const token = this.$route.params.token;
    const id = this.$route.params.id;
    
    this.get_template_public(id, token);
  },
  watch: {
    
  },
  methods: {

    cleanHtml(raw) {
      // Test 1: Är råsträngen ett giltigt JSON-string-literal?
      try {
        return JSON.parse(raw);      // tar bort \" och \n korrekt
      } catch (_) {}

      // Test 2: Är den HTML-entitetskodad (&lt; &gt;)?
      if (raw.includes('&lt;') && raw.includes('&gt;')) {
        const textArea = document.createElement('textarea');
        textArea.innerHTML = raw;
        return textArea.value;       // entitets-decode
      }

      // Fallback: manuell backslash-städning
      return raw
        .replace(/\\n/g, '\n')
        .replace(/\\r/g, '')
        .replace(/\\"/g, '"')
        .replace(/\\'/g, "'");
    },

    async get_template_public(id, token) {
      const res = await axios.get(`/template/public/${id}/${token}`);

      try {
        if (res.status === 200) {
          this.template = res.data;
          this.html = this.cleanHtml(this.template.template);
          console.log('html', this.html)
        }
      }
      catch (err) {
        console.error('get_template_public error', err);
      }
      
    },
  }
};
</script>
